export const SET_USER = 'SET_USER';
export const SET_USERS = 'SET_USERS';
export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SET_TOKEN = 'SET_TOKEN';
export const LOGOUT_USER = 'LOGOUT_USER';


